var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.needHeader)?_c('header',[_c('v-header')],1):_vm._e(),_c('div',{staticClass:"main",style:({ height: _vm.contH })},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }